import { render } from "./messages.vue?vue&type=template&id=60a2d141&scoped=true"
import script from "./messages.vue?vue&type=script&lang=js"
export * from "./messages.vue?vue&type=script&lang=js"

import "./messages.vue?vue&type=style&index=0&id=60a2d141&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a2d141"]])

export default __exports__